import React, { FunctionComponent } from "react";

const ControlsNextIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/video-movies-tv/controls/controls-next
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>controls-next</title>
      <path
        d="M.75,3.629V20.371a.75.75,0,0,0,1.175.618L14.1,12.618a.749.749,0,0,0,0-1.236L1.925,3.011A.75.75,0,0,0,.75,3.629Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <rect
        x="18.75"
        y="2.25"
        width="4.5"
        height="19.5"
        rx="1.5"
        ry="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
    </svg>
  );
};

export default ControlsNextIcon;
